import { UtmCampaign, UtmMedium, UtmSource } from '@/app/enums';

const FACEBOOK_SHARER_BASE_URL = 'https://www.facebook.com/sharer/sharer.php';
const X_TWEET_BASE_URL = 'https://twitter.com/intent/tweet';
const WHATSAPP_BASE_URL = 'whatsapp://send';

export const getBaseUrlForSharing = (projectSlug: string, subProjectSlug: string | undefined) => {
  const baseUrl = process.env.NEXT_PUBLIC_REDIRECT_URL;

  if (baseUrl?.endsWith('/')) {
    return `${baseUrl}${projectSlug}${subProjectSlug ? `/${subProjectSlug}` : ''}`;
  }

  return `${baseUrl}/${projectSlug}${subProjectSlug ? `/${subProjectSlug}` : ''}`;
};

export const getShareLink = (
  pageUrl: string,
  searchParams?: {
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    utmContent?: string;
  },
) => {
  const params = new URLSearchParams();

  params.set('utm_source', searchParams?.utmSource ?? UtmSource.COPYLINK);
  params.set('utm_medium', searchParams?.utmMedium ?? UtmMedium.SOCIAL_SHARE);
  params.set('utm_campaign', searchParams?.utmCampaign ?? UtmCampaign.SHARE_BUTTON);

  if (searchParams?.utmContent) {
    params.set('utm_content', searchParams.utmContent);
  }

  return `${pageUrl}?${params.toString()}`;
};

export const getFacebookShareLink = (
  pageUrl: string,
  searchParams?: { utmSource?: string; utmMedium?: string; utmCampaign?: string; utmContent?: string },
) => {
  const params = new URLSearchParams();

  params.set('u', getShareLink(pageUrl, searchParams));

  return `${FACEBOOK_SHARER_BASE_URL}?${params.toString()}`;
};

export const getXShareLink = (
  text: string,
  pageUrl: string,
  searchParams?: {
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    utmContent?: string;
  },
) => {
  const url = getShareLink(pageUrl, searchParams);
  const params = new URLSearchParams();

  params.set('url', url);
  params.set('text', text);

  return `${X_TWEET_BASE_URL}?${params.toString()}`;
};

export const getWhatsappShareLink = (
  text: string,
  pageUrl: string,
  searchParams?: { utmSource?: string; utmMedium?: string; utmCampaign?: string; utmContent?: string },
) => {
  const params = new URLSearchParams();

  params.set('text', `${text}\n\n${getShareLink(pageUrl, searchParams)}`);

  return `${WHATSAPP_BASE_URL}?${params.toString()}`;
};
